module.exports = __webpack_public_path__ + "img/fill_main1.d13ad189.png";